export enum PlanType {
  'Private/Commercial' = 0,
  'Medicare Part D' = 1,
  'Medicare Advantage' = 2,
  'Medicaid' = 3,
  'VA or Military' = 4,
}
